import { FC } from "react";

import { useTranslation, Enterprise } from "@ctra/i18n";
import { Breadcrumbs } from "@ctra/api";

import { InsightList, useLatestInsights } from "@insights";
import { Routes } from "@routes";

import styles from "./InsightListPage.module.less";

const { Breadcrumb } = Breadcrumbs.components;

/**
 * Insight list page
 * @constructor
 */
const InsightListPage: FC = () => {
  const { t } = useTranslation();
  const { insightListQuery, insightListName } = useLatestInsights();

  return (
    <>
      <Breadcrumb path={Routes.app.insights.index} title={t<string>(Enterprise.navigation.main.insights)} />
      <section className={styles.PageContent}>
        <InsightList query={insightListQuery} list={`${insightListName}-insightListPage`} wide />
      </section>
    </>
  );
};

export default InsightListPage;
